module.exports = __webpack_public_path__ + "img/mediation.f34e1304.svg";